/**
 * Slug generation utilities for human-readable permalinks.
 */
/** Convert a name to a URL-friendly slug. */
export function slugify(name) {
    return (name
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // strip diacritics (Latin accents \u2192 base letter)
        // Keep ANY Unicode letter/number, not just a-z0-9 \u2014 otherwise non-Latin titles
        // (Armenian, Cyrillic, CJK, \u2026) get fully stripped and every record collapses to
        // "untitled". Modern browsers/Express handle UTF-8 slug segments fine.
        .replace(/[^\p{L}\p{N}]+/gu, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 80) || 'untitled');
}
/**
 * Generate a unique slug within a scope by appending -2, -3, etc. if needed.
 * @param base - the base slug (already slugified)
 * @param existingSlugs - set or array of slugs already taken in the same scope
 */
export function uniqueSlug(base, existingSlugs) {
    const taken = existingSlugs instanceof Set ? existingSlugs : new Set(existingSlugs);
    if (!taken.has(base))
        return base;
    let i = 2;
    while (taken.has(`${base}-${i}`))
        i++;
    return `${base}-${i}`;
}
/** Return the canonical permalink segment for a user. */
export function getUserPermalinkSegment(user) {
    return user.slug?.trim() || user.id;
}
//# sourceMappingURL=slugify.js.map